import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=32789a80&scoped=true&"
import script from "./EN.vue?vue&type=script&lang=js&"
export * from "./EN.vue?vue&type=script&lang=js&"
import style0 from "./EN.vue?vue&type=style&index=0&id=32789a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32789a80",
  null
  
)

export default component.exports